



































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { PDFDocumentProxy } from "pdfjs-dist/types/src/display/api";
import * as PDFJS from "pdfjs-dist/legacy/build/pdf";
import { TextLayerBuilder, EventBus } from "pdfjs-dist/legacy/web/pdf_viewer";
import "pdfjs-dist/legacy/web/pdf_viewer.css";
import "pdfjs-dist/legacy/build/pdf.worker.entry";

@Component({
  name: "Pdf",
  components: {}
})
export default class Pdf extends Vue {
  private index: number = 1;
  private total: number = 0;

  private $main!: HTMLDivElement;

  private invalid: boolean = false;

  private isFull: boolean = false;

  /**
   * PDF路径
   */
  @Prop({
    required: true
  })
  private src!: string;

  /**
   * 是否渲染文本图层
   */
  @Prop({
    default: () => false
  })
  private needText!: boolean;

  private doc!: PDFDocumentProxy;

  async full() {
    if (this.isFull) {
      await document.exitFullscreen();
      this.isFull = false;
    } else {
      await this.$el.requestFullscreen();
      this.isFull = true;
    }
  }

  download() {
    const a = document.createElement("a") as HTMLAnchorElement;
    a.href = this.src;
    a.download = "下载.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  gotop() {
    this.$main.scrollTop = 0;
    this.index = 1;
  }

  scrollTo() {
    if (this.index + "" === "" || this.index < 1) {
      this.index = 1;
    }

    if (this.index > this.total) {
      this.index = this.total;
    }

    if (this.index === 1) {
      this.$main.scrollTop = 0;
    } else {
      let h = 0;
      for (let i = 1; i < this.index; i++) {
        const rect = (
          this.$el.querySelector("#pagebox" + i) as HTMLDivElement
        ).getBoundingClientRect();
        h += rect.height;
      }
      this.$main.scrollTop = h;
    }
  }

  async display(index: number) {
    const page = await this.doc.getPage(index);
    const canvas = (this.$refs.page as HTMLCanvasElement[])[index - 1];
    const box = (this.$refs.pagebox as HTMLDivElement[])[index - 1];

    if (!box || !box.getBoundingClientRect) return;

    const rect = box.getBoundingClientRect();

    const scale = rect.width / page.getViewport({ scale: 1 }).width;
    const viewport = page.getViewport({ scale });

    canvas.width = viewport.width;
    canvas.height = viewport.height;

    box.style.height = viewport.height + 10 + "px";

    const canvasContext = canvas.getContext("2d") as CanvasRenderingContext2D;
    await page.render({ viewport, canvasContext }).promise;

    if (!this.needText) return;

    page.getTextContent().then((content) => {
      const ctx = this.$el.querySelector("#textctx" + index) as HTMLElement;

      const textLayerDiv = document.createElement("div") as HTMLDivElement;
      textLayerDiv.setAttribute("class", "textLayer");
      ctx.appendChild(textLayerDiv);

      const textLayer = new TextLayerBuilder({
        textLayerDiv: textLayerDiv,
        pageIndex: index,
        viewport: viewport,
        eventBus: new EventBus()
      });

      textLayer.setTextContent(content);
      textLayer.render();
    });
  }

  async renderPdf() {
    this.$nextTick(async () => {
      for (let i = 1; i <= this.total; i++) {
        await this.display(i);
      }
    });
  }

  async start() {
    try {
      this.doc = await PDFJS.getDocument(this.src).promise;
      this.total = this.doc.numPages;
      await this.renderPdf();
    } catch (error) {
      console.log(error);
      this.invalid = true;
    }
  }

  async mounted() {
    this.$main = this.$refs.main as HTMLDivElement;
    await this.start();
    let timer: any;
    window.addEventListener("resize", () => {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        this.renderPdf();
      }, 300);
    });
  }

  @Watch("src")
  onSrcChange() {
    this.start();
  }

  @Watch("needText")
  onNeedTextChange() {
    this.renderPdf();
  }
}
